var managePop;

var avalon = require("avalon"),
    $ = require("jquery"),
    ajax = require("ajax"),
    dialog = require("dialog"),
    tool = require("toolLoaderPC"),
    pagination = require("pagination"),
    vmodel = avalon.define({
        $id: "groupViewController",
        isJoin: 0,
        menu: "hot",
        toggleMenu: function(type) {
            vmodel.menu = type.toString();
            $("body").scroll();
        },
        // 加入小组
        join: function() {
            if (window.server.islogin) {
                tool.singleWay("join", function(key) {
                    var kit = this;
                    ajax.getWithFail(window.server.joinUrl)
                        .done(function(response) {
                            vmodel.isJoin = 1;
                            dialog.alert("关注小组成功！");
                            kit.resolve(key);
                        })
                        .fail(function() {
                            kit.resolve(key);
                        });
                });
            } else {
                ajax.pjax(window.server.loginUrl);
            }
        },
        // 退出小组
        exit: function() {
            if (window.server.islogin) {
                tool.singleWay("exit", function(key) {
                    var kit = this;
                    dialog.confirm(
                        "确定要取消关注吗？<br/>重逢当喜悦，离别不伤悲~",
                        function() {
                            ajax.getWithFail(window.server.exitUrl)
                                .done(function(response) {
                                    vmodel.isJoin = 0;
                                    dialog.alert("取消关注成功！");
                                    kit.resolve(key);
                                })
                                .fail(function() {
                                    kit.resolve(key);
                                });
                        },
                        function() {
                            kit.resolve(key);
                        }
                    );
                });
            } else {
                ajax.pjax(window.server.loginUrl);
            }
        },
        // 最后回复的分页
        newReplyPage: {},
        newReplyPagination: [],
        newReplyGoPage: function(page) {
            if (page.disable) {
                return;
            }
            ajax.pjax(window.server.loadNewReplyUrl + "&page=" + page.target);
        },
        // 最新的分页
        newPage: {},
        newPagination: [],
        newGoPage: function(page) {
            if (page.disable) {
                return;
            }
            ajax.pjax(window.server.loadNewUrl + "&page=" + page.target);
        },
        // 最热的分页
        hotPage: {},
        hotPagination: [],
        hotGoPage: function(page) {
            if (page.disable) {
                return;
            }
            ajax.pjax(window.server.loadHotUrl + "&page=" + page.target);
        },

        // 页码
        // consultPagination: [],
        // consultGoPage: function(page){
        //     if (page.disable) {
        //         return;
        //     }
        //     ajax.pjax(window.server.loadUrl + "&page=" +page.target);
        // },
        jump: function(url) {
            ajax.pjax(url);
        },
        toTopVisible: false,
        toTopPositionBottom: 357,
        toTop: function() {
            tool.scrollTo($("#header"));
        }
    });

export default {
    init: function() {
        vmodel.newReplyPage = window.server.NewReplyPage;
        vmodel.newPage = window.server.NewPage;
        vmodel.hotPage = window.server.HotPage;

        vmodel.newReplyPagination = pagination.init(
            vmodel.newReplyPage.total_count,
            vmodel.newReplyPage.page,
            vmodel.newReplyPage.page_size
        );
        vmodel.newPagination = pagination.init(
            vmodel.newPage.total_count,
            vmodel.newPage.page,
            vmodel.newPage.page_size
        );
        vmodel.hotPagination = pagination.init(
            vmodel.hotPage.total_count,
            vmodel.hotPage.page,
            vmodel.hotPage.page_size
        );

        $(".lazy-background").lazyload({
            effect: "fadeIn",
            placeholder:
                window.server.cdnHost + "/dest/quanzi/images/default200.jpg",
            threshold: 300
        });

        // 判断是否加入
        vmodel.isJoin = window.server.isJoin ? 1 : 0;
        // 回到顶部DIV状态
        tool.onWindowScroll.on(function(e, top) {
            if (top === 0) {
                vmodel.toTopVisible = false;
            } else {
                vmodel.toTopVisible = true;
            }

            var clientHeight = tool.getClientHeight(),
                scrollHeight = tool.getScrollHeight();

            if (scrollHeight - clientHeight - top < 357) {
                vmodel.toTopPositionBottom =
                    357 - (scrollHeight - clientHeight - top);
            } else {
                vmodel.toTopPositionBottom = 20;
            }
        });
    },
    clear: function() {
        tool.onWindowScroll.clear();
    }
};
